import React, { useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import teamEditionLogo from '../../assets/icons/teamEdition.png'
import portalEditionLogo from '../../assets/icons/portalEdition.png'
import { v2Url } from '../../redux/config';
import { useAuth } from '../../context/AuthContext';

const SelectVersion = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const basicUserToken = sessionStorage.getItem('basicUserToken') || null;
    const proUserToken = sessionStorage.getItem('proUserToken') || null;

    useEffect(() => {
        if (!basicUserToken && !proUserToken) {
            navigate('/');
        }
    }, [basicUserToken, proUserToken, navigate]);

    const handlePortalClick = () => {
        localStorage.setItem('redirectToken', basicUserToken);
        window.open(`${window.location.protocol}//${window.location.host}/re-direct`);
    };

    const handleTeamClick = () => {
        const newWindow = window.open(`${v2Url}/re-direct`);
        const handleReady = (event) => {
            if (event.origin !== v2Url || event.data?.type !== 'READY') return;
            window.removeEventListener('message', handleReady);
            newWindow?.postMessage({ redirectToken: proUserToken }, v2Url);
        };
        window.addEventListener('message', handleReady);
    };

    const versions = [
        {
            name: 'Portal Edition',
            img: portalEditionLogo,
            isDisabled: basicUserToken === "null",
            onCardClick: handlePortalClick,
        },
        {
            name: 'Team Edition',
            img: teamEditionLogo,
            isDisabled: proUserToken === "null",
            onCardClick: handleTeamClick,
        },
    ];

    const renderVersionCard = ({ name, img, isDisabled, onCardClick }) => (
        <div
            key={name}
            className={`curved-cards p-4 text-center mx-md-5 my-5 w-100 h-100 ${isDisabled ? 'disabled' : 'cursor_pointer'
                }`}
            style={{
                maxWidth: '25rem',
                maxHeight: '20rem',
                backgroundColor: isDisabled ? '#d3d5d6' : '',
                pointerEvents: isDisabled ? 'none' : 'auto',
            }}
            aria-disabled={isDisabled}
            onClick={() => !isDisabled && onCardClick()}
        >
            <Image alt={`${name} logo`} src={img} height={120} className="mx-auto rounded" />
            <h5
                className={`my-4 fn_Roboto fw_400 fs_28 text-nowrap fn_sans ${isDisabled && 'text-black-50'}`}
            >
                {name}
            </h5>
        </div>
    );

    return (
        <div
            className="w-100 vh-100 d-flex flex-column"
            style={{ backgroundColor: '#e9eef7' }}
        >

            <div className='d-flex justify-content-between w-100' >
                {/* Image div */}
                <Image
                    alt="Acumen Logo"
                    src={logo}
                    height={40}
                    className="mx-1 mt-2"
                    style={{ zIndex: '1000' }}
                />
                <div>
                    <p className="fs_38 fn_sans fw_400 m-0 text-center text-dark ">Acumen Translation Hub</p>
                </div>

                <div>
                    <button type='button'
                        onClick={logout}
                        className="btn btn-danger custom-hover mx-2 mt-2 border-0">
                        Logout
                    </button>
                </div>
            </div>


            {/* Main Content */}
            <div
                className="d-flex justify-content-center align-items-center flex-grow-1"
                style={{ backgroundColor: '#e9eef7' }}
            >
                <div
                    className="bg-white rounded shadow d-flex flex-column align-items-center overflow-auto"
                    style={{
                        width: '75vw',
                        height: '75vh',
                        padding: '1.5rem',
                    }}
                >
                    {/* Title at the Top */}
                    <h5
                        className="text-center mb-4 fs_28 fn_sans fw_400"
                        style={{
                            position: 'relative',
                            top: 0,
                            marginBottom: '1.5rem',
                        }}
                    >
                        Choose Edition To Continue
                    </h5>

                    {/* Cards */}
                    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center w-100 flex-grow-1">
                        {versions.map(renderVersionCard)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectVersion;

